import React from 'react';
import { StyledTable, BlockLayout } from './styled';
const renderMap = {
    block: ({ children, className, ...props }) => (React.createElement(BlockLayout, { role: "table", className: `sticky${className ? ` ${className}` : ''}`, ...props }, children)),
    table: ({ children, ...props }) => (React.createElement(StyledTable, { ...props }, children))
};
export const Table = ({ children, layoutType, ...props }) => {
    const renderTable = renderMap[layoutType];
    return renderTable({ children, ...props });
};
